import { getDialogHooks } from 'utilities/dialog-context/DialogContextHelpers';
import MemberStatusChangeRequestDialog, {
  MemberStatusChangeRequestCallbackInput,
  MemberStatusChangeRequestDialogUniqueProps,
} from '../MemberStatusChangeRequestDialog';

const { useDialogForContext, useDialog: useMemberStatusChangeRequestDialog } =
  getDialogHooks<
    MemberStatusChangeRequestDialogUniqueProps,
    MemberStatusChangeRequestCallbackInput
  >(MemberStatusChangeRequestDialog);
export const useMemberStatusChangeRequestDialogForContext = useDialogForContext;
export default useMemberStatusChangeRequestDialog;
